import "../styles/style.css";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();

    const [showButton, setShowButton] = useState(false);

    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY >= 300);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <footer>
                <p className="text-footer">
                    &copy; 2025 - {currentYear} {t("footer.text")}
                </p>
            </footer>

            {showButton && (
                <button
                    className="btn"
                    onClick={() =>
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        })
                    }
                >
                    <i className="fa fa-chevron-up"></i>
                </button>
            )}
        </>
    );
}